module.exports = __webpack_public_path__ + "img/none_icon@2x.1c6074c9.png";